import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import { connect } from 'react-redux'
// import { dissoc, curry, repeat } from 'ramda'

import { API_URL } from 'src/config'
import { orderFieldNames, deliveryTypes } from '../../../../constants'
import OrderForYourselfView from './View'

OrderForYourselfContainer.propTypes = {
  city: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,

  authToken: PropTypes.any.isRequired
}

const mapStateToProps = state => ({
  authToken: state.user.authToken
})

export default connect(mapStateToProps)(OrderForYourselfContainer)

function OrderForYourselfContainer({
  city,
  authToken,
  onSubmitSuccess,
  onClickPreviousButton
}) {
  // const [hasFamily, setHasFamily] = useState(false)
  // const [familyMembersNumber, setFamilyMembersNumber] = useState(1)
  const [stateServerError, setServerError] = useState('')

  const formikBag = useFormik({
    initialValues: {
      [orderFieldNames.CITY]: city.id,
      [orderFieldNames.ADDRESS]: '',
      [orderFieldNames.DELIVERY]: city.has_delivery ? deliveryTypes.COURIER : deliveryTypes.PICKUP /* deliveryTypes.COURIER */,
      /* [orderFieldNames.FAMILY]: repeat({
        [orderFieldNames.FAMILY_LASTNAME]: '',
        [orderFieldNames.FAMILY_NAME]: '',
        [orderFieldNames.FAMILY_PATRONYMIC]: '',
        [orderFieldNames.FAMILY_CONTACT]: '',
        [orderFieldNames.FAMILY_KINSHIP]: ''
      }, familyMembersNumber) */
    },

    validationSchema: Yup.object().shape({
      [orderFieldNames.ADDRESS]: Yup.string().when([orderFieldNames.DELIVERY], {
        is: deliveryTypes.COURIER,
        then: Yup.string().required('Обязательное поле')
      }),

      /* [orderFieldNames.FAMILY]: hasFamily && Yup.array().of(Yup.object().shape({
        [orderFieldNames.FAMILY_LASTNAME]: Yup.string().required('Обязательное поле'),
        [orderFieldNames.FAMILY_NAME]: Yup.string().required('Обязательное поле'),
        [orderFieldNames.FAMILY_PATRONYMIC]: Yup.string().required('Обязательное поле'),
        [orderFieldNames.FAMILY_CONTACT]: Yup.string().required('Обязательное поле'),
        [orderFieldNames.FAMILY_KINSHIP]: Yup.string().required('Обязательное поле')
      })) */
    }),

    onSubmit: values => {
      let preparedValues
      
      preparedValues = values
      // if (hasFamily) {
      //   preparedValues = values
      // } else {
      //   preparedValues = dissoc(orderFieldNames.FAMILY, values)
      // }

      axios({
        method: 'post',
        url: `${API_URL}/order/`,
        data: {...preparedValues},
        headers: {
          'Authorization': `Token ${authToken}`
        }
      }).then(res => {
        onSubmitSuccess()
        setServerError('')
        // console.log(res)
      }).catch(err => {
        setServerError(err?.response?.data?.detail || 'Неизвестная ошибка')
        // console.error(err?.response)
      })
    }
  }, [/* familyMembersNumber, hasFamily */])

  // function onToggleFamilyHandler() {
  //   setHasFamily(!hasFamily)
  // }

  // const onClickAddFamilyMember = curry((arrayHelpers, event) => {
  //   setFamilyMembersNumber(familyMembersNumber + 1)
  //   arrayHelpers.push('')
  // })

  return (
    <OrderForYourselfView
      values={formikBag.values}
      handleChange={formikBag.handleChange}
      handleSubmit={formikBag.handleSubmit}
      cityName={city.name}
      cityHasDelivery={city.has_delivery}
      formikBag={formikBag}
      // onToggleFamily={onToggleFamilyHandler}
      // hasFamily={hasFamily}
      errors={formikBag.errors}
      touched={formikBag.touched}
      // onClickAddFamilyMember={onClickAddFamilyMember}
      onClickPreviousButton={onClickPreviousButton}
      serverError={stateServerError}
    />
  )
}
